import UserHead from './user-head.vue'
import LoginAndRegisterDialog from './authentication/login-register.vue'
import HbCopyright from './copyright.vue'
import HbSku from './sku/index.vue'
import HbEmpty from './util/empty.vue'

class Components {
  install(Vue: any) {
    Vue.component('UserHead', UserHead)
    Vue.component('LoginAndRegisterDialog', LoginAndRegisterDialog)
    Vue.component('HbCopyright', HbCopyright)
    Vue.component('HbSku', HbSku)
    //
    Vue.component('HbEmpty', HbEmpty)
  }
}

export default new Components()
